'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  ', ';\n\n  ', ';\n'], ['\n  ', ';\n\n  ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  transition-property: ', ';\n  transition-duration: ', 'ms;\n  opacity: ', ';\n  transform: ', ';\n  ', ';\n'], ['\n  transition-property: ', ';\n  transition-duration: ', 'ms;\n  opacity: ', ';\n  transform: ', ';\n  ', ';\n']);

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _UIPopoverHeader = require('./UIPopoverHeader');

var _UIPopoverHeader2 = _interopRequireDefault(_UIPopoverHeader);

var _UIPopoverBody = require('./UIPopoverBody');

var _UIPopoverBody2 = _interopRequireDefault(_UIPopoverBody);

var _UIPopoverFooter = require('./UIPopoverFooter');

var _UIPopoverFooter2 = _interopRequireDefault(_UIPopoverFooter);

var _UIPopoverArrow = require('./UIPopoverArrow');

var _UIPopoverArrow2 = _interopRequireDefault(_UIPopoverArrow);

var _PlacementConstants = require('./PlacementConstants');

var _TwoWayTransition = require('../transitions/TwoWayTransition');

var _TwoWayTransition2 = _interopRequireDefault(_TwoWayTransition);

var _times = require('HubStyleTokens/times');

var _decorators = require('../utils/propTypes/decorators');

var _Functions = require('../core/Functions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var POSITION_RELATIVE = {
  position: 'relative'
};

var USE_CLASSES = {
  default: 'uiPopover--default private-popover--default',
  longform: 'private-tooltip--longform',
  shepherd: 'private-popover--shepherd',
  tooltip: 'private-popover--tooltip',
  'tooltip-danger': 'private-popover--tooltip private-popover--tooltip-danger',
  unstyled: 'private-popover--unstyled'
};

var getPopoverClassName = function getPopoverClassName(className, use) {
  return (0, _reactUtils.classNames)(className, USE_CLASSES[use], 'private-popover', 'uiPopover');
};

var renderArrow = function renderArrow(arrowColor, arrowSize, placement) {
  var computedArrowParams = _UIPopoverArrow2.default.ARROW_SIZES[arrowSize];
  return _react2.default.createElement(_UIPopoverArrow2.default, {
    color: arrowColor,
    inset: computedArrowParams.inset,
    key: 'arrow',
    placement: placement,
    width: computedArrowParams.width
  });
};

var renderStructuredContent = function renderStructuredContent(content, placement, renderedArrow) {
  var header = content.header,
      body = content.body,
      footer = content.footer;

  var headerArrow = placement.match(/bottom/) ? renderedArrow : null;
  var bodyArrow = placement.match(/bottom|top/) ? null : renderedArrow;
  var footerArrow = placement.match(/top/) ? renderedArrow : null;
  return [header ? _react2.default.createElement(
    _UIPopoverHeader2.default,
    { key: 'header' },
    header,
    headerArrow
  ) : headerArrow, body ? _react2.default.createElement(
    _UIPopoverBody2.default,
    { key: 'body' },
    body,
    bodyArrow
  ) : bodyArrow, footer ? _react2.default.createElement(
    _UIPopoverFooter2.default,
    { key: 'footer' },
    footer,
    footerArrow
  ) : footerArrow];
};

var renderPopoverContent = function renderPopoverContent(arrowColor, arrowSize, className, content, id, open, placement, width, style, use, rest, openComplete) {
  var widthStyle = width ? { maxWidth: width, width: width } : {};
  var renderedArrow = renderArrow(arrowColor, arrowSize, placement);

  if (open) {
    return _react2.default.createElement(
      'div',
      _extends({
        className: getPopoverClassName(className, use),
        'data-open-complete': openComplete,
        id: id,
        style: _extends({}, POSITION_RELATIVE, widthStyle, style)
      }, rest),
      _react2.default.isValidElement(content) ? [renderedArrow, _react2.default.createElement(
        'div',
        { key: 'content' },
        content
      )] : renderStructuredContent(content, placement, renderedArrow)
    );
  }

  return null;
};

var transformOriginMixin = (0, _styledComponents.css)(_templateObject, ['top', 'bottom', 'left', 'right'].map(function (side) {
  return '.tether-element-attached-' + side + ' & { transform-origin: ' + side + ' }';
}), ['top', 'bottom'].map(function (ySide) {
  return ['left', 'right'].map(function (xSide) {
    return '.tether-element-attached-' + ySide + '.tether-element-attached-' + xSide + ' & { transform-origin: ' + ySide + ' ' + xSide + ' }';
  });
}));

var PopoverTransitionWrapper = (0, _styledComponents2.default)(_TwoWayTransition2.default.PlainWrapper).withConfig({
  displayName: 'UIPopoverContent__PopoverTransitionWrapper'
})(_templateObject2, function (_ref) {
  var transitioning = _ref.transitioning;
  return transitioning ? 'opacity, transform' : 'none';
}, function (_ref2) {
  var duration = _ref2.duration;
  return duration;
}, function (props) {
  return props.hidden ? '0.01' : '1';
}, function (props) {
  if (!props.transitioning) return 'none';
  return props.hidden ? 'scale(.75)' : 'scale(1)';
}, transformOriginMixin);

var UIPopoverContent = _react2.default.createClass({
  displayName: 'UIPopoverContent',

  mixins: [_reactAddonsPureRenderMixin2.default],

  propTypes: {
    animateOnMount: _react.PropTypes.bool.isRequired,
    animateOnToggle: _react.PropTypes.bool.isRequired,
    hasRendered: (0, _decorators.hidden)(_react.PropTypes.bool.isRequired),
    arrowColor: _react.PropTypes.string,
    arrowSize: _react.PropTypes.oneOf(Object.keys(_UIPopoverArrow2.default.ARROW_SIZES)).isRequired,
    className: _react.PropTypes.string,
    content: _react.PropTypes.oneOfType([_react.PropTypes.node, _react.PropTypes.shape({
      header: _react.PropTypes.node,
      body: _react.PropTypes.node,
      footer: _react.PropTypes.node
    })]).isRequired,
    id: _react.PropTypes.string,
    onCloseComplete: _react.PropTypes.func,
    onCloseStart: _react.PropTypes.func,
    onOpenComplete: _react.PropTypes.func,
    onOpenStart: _react.PropTypes.func,
    open: _react.PropTypes.bool,
    placement: _react.PropTypes.oneOf(_PlacementConstants.PLACEMENTS).isRequired,
    style: _react.PropTypes.object,
    use: _react.PropTypes.oneOf(Object.keys(USE_CLASSES)),
    width: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number])
  },

  getDefaultProps: function getDefaultProps() {
    return {
      animateOnMount: false,
      animateOnToggle: true,
      hasRendered: false,
      open: false,
      placement: 'top',
      use: 'default'
    };
  },
  getInitialState: function getInitialState() {
    var _props = this.props,
        open = _props.open,
        animateOnMount = _props.animateOnMount,
        animateOnToggle = _props.animateOnToggle,
        hasRendered = _props.hasRendered;

    return {
      openComplete: open && !(animateOnMount && !hasRendered) && !(animateOnToggle && hasRendered)
    };
  },
  handleOpenComplete: function handleOpenComplete() {
    var onOpenComplete = this.props.onOpenComplete;

    this.setState({ openComplete: true });
    (0, _Functions.callIfPossible)(onOpenComplete);
  },
  handleCloseStart: function handleCloseStart() {
    var onCloseStart = this.props.onCloseStart;

    this.setState({ openComplete: false });
    (0, _Functions.callIfPossible)(onCloseStart);
  },
  render: function render() {
    var _props2 = this.props,
        animateOnMount = _props2.animateOnMount,
        animateOnToggle = _props2.animateOnToggle,
        arrowColor = _props2.arrowColor,
        arrowSize = _props2.arrowSize,
        className = _props2.className,
        content = _props2.content,
        hasRendered = _props2.hasRendered,
        id = _props2.id,
        onCloseComplete = _props2.onCloseComplete,
        __onCloseStart = _props2.onCloseStart,
        __onOpenComplete = _props2.onOpenComplete,
        onOpenStart = _props2.onOpenStart,
        open = _props2.open,
        placement = _props2.placement,
        style = _props2.style,
        use = _props2.use,
        width = _props2.width,
        rest = _objectWithoutProperties(_props2, ['animateOnMount', 'animateOnToggle', 'arrowColor', 'arrowSize', 'className', 'content', 'hasRendered', 'id', 'onCloseComplete', 'onCloseStart', 'onOpenComplete', 'onOpenStart', 'open', 'placement', 'style', 'use', 'width']);

    var openComplete = this.state.openComplete;


    return _react2.default.createElement(
      _TwoWayTransition2.default,
      {
        onCloseComplete: onCloseComplete,
        onCloseStart: this.handleCloseStart,
        onOpenComplete: this.handleOpenComplete,
        onOpenStart: onOpenStart,
        transitionOnMount: animateOnMount && !hasRendered || animateOnToggle && hasRendered,
        duration: animateOnToggle ? parseInt(_times.POPOVER_TRANSITION_TIMING, 10) : 0,
        Wrapper: PopoverTransitionWrapper
      },
      renderPopoverContent(arrowColor, arrowSize, className, content, id, open, placement, width, style, use, rest, openComplete)
    );
  }
});

exports.default = UIPopoverContent;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1552/js/tooltip/UIPopoverContent.js
// module id = 301
// module chunks = 0